/**
 * Parsing methods.
 * @module parse
 */
define(function(require, exports, module) {

    'use strict';

     var jorTransferGroups = {'efawateercom':'eFAWATEERcom', 'myfund':'Between My Accounts', 'domestic':'Domestic', 'international':'abc.common.international', 'creditcard':'abc.common.credit.card', 'bill': 'abc.common.bill'};
     var bahTransferGroups = {'myfund' : 'Between My Accounts', 'domestic':'Within Bank ABC', 'international':'Interbank','creditcard':'abc.common.credit.card', 'bill': 'abc.common.bill'};
     var base = require('base');
     var lpPortal = base.inject('lpPortal', require('../portal/main').name);
     var isMobileNative = window.cxp && window.cxp.mobile ? true : false;
     var portalName, title;

     exports.getTransferGroupTitle = function (groupTitle) {
        portalName = isMobileNative ? window.localStorage.getItem("portalName") : lpPortal.name;

        if(portalName === 'jo' || portalName === 'dz' || portalName === 'to' || portalName === 'tn'){
          title = jorTransferGroups[groupTitle.toLowerCase()];
        } else {
          title = bahTransferGroups[groupTitle.toLowerCase()];
        }

        return title || groupTitle;
     };
});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/utils/transfer-group-title.js
// module id = 37
// module chunks = 0